// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * Represents the GridToolbar component.
 *
 * @example
 * ```tsx-no-run
 *   <div id="app">
 *       <Grid
 *           :data-items="products"
 *           :columns="columns">
 *       <grid-toolbar >
 *           <button title="Add new" class="k-button k-primary" @click='insert' >
 *                   Add new
 *           </button>
 *           <button v-if="hasItemsInEdit"
 *               title="Cancel current changes"
 *               class="k-button"
 *               @click="cancelChanges">
 *               Cancel current changes
 *           </button>
 *           </grid-toolbar>
 *       </Grid>
 *   </div>
 * <script>
 *       Vue.component('Grid', Grid);
 *       Vue.component('grid-toolbar', GridToolbar);
 *       new Vue({
 *           el: '#app',
 *           data: function () {
 *               return {
 *                  products: [
 *                    { 'foo': 'A1', 'bar': 'B1' },
 *                       { 'foo': 'A2', 'bar': 'B2' },
 *                       { 'foo': 'A3', 'bar': 'B2' }
 *                   ],
 *                   columns: [
 *                       { field: 'foo'},
 *                       { field: 'bar'}
 *                   ]
 *               };
 *           }
 *       });
 *   </script>
 * ```
 */

/**
 * Represents the default `GridToolbar` component.
 */

var GridToolbar = {
  name: 'GridToolbar',
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("div", {
      "class": "k-header k-grid-toolbar"
    }, [defaultSlot]);
  }
};
export { GridToolbar };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-grid/dist/es/GridToolbar.js
// module id = 815
// module chunks = 93